import {useCallback, useEffect, useState} from 'react'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import type {RunnersResponse} from '../types'

export interface ApiResponse {
  runnersResponse: RunnersResponse
  isLoading: boolean
  error: boolean
  retry: () => void
}

export function useRunners(endpoint: string): ApiResponse {
  const [runnersResponse, setRunnersResponse] = useState<RunnersResponse>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)
  const [requestVersion, setRequestVersion] = useState(0)
  const retry = useCallback(() => setRequestVersion(version => version + 1), [])

  useEffect(() => {
    let cancelled = false

    const fetchData = async () => {
      setIsLoading(true)
      setError(false)

      try {
        const response = await verifiedFetchJSON(endpoint)
        if (!response.ok) {
          if (!cancelled) setError(true)
          return
        }

        const data = await response.json()
        if (!cancelled) setRunnersResponse(data)
      } catch {
        if (!cancelled) setError(true)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    fetchData()
    return () => {
      cancelled = true
    }
  }, [endpoint, requestVersion])

  return {
    runnersResponse,
    isLoading,
    error,
    retry,
  }
}
